export default __webpack_public_path__ + "static/media/teeth - inactive_v1.bd1bce2b.svg";